import { ApprovalTerm } from 'api/application'

export function getMaxFinancedAmount(approvalTerm: ApprovalTerm) {
    const maxFinanced =
        Number(approvalTerm?.computed_max_finance) +
        Number(approvalTerm?.additional_oem_accessories_dollar_amount)

    if (
        approvalTerm?.is_all_in_advance === true &&
        approvalTerm?.all_in_advance_max_finance != null
    ) {
        return Math.min(
            maxFinanced,
            Number(approvalTerm.all_in_advance_max_finance),
        )
    }

    return maxFinanced
}

export function getMaxFinancedTerm(approvalTerms: ApprovalTerm[]) {
    return approvalTerms.reduce(
        (maxFinancedTerm, approvalTerm: ApprovalTerm) => {
            if (!maxFinancedTerm) {
                return approvalTerm
            }

            const currentApprovalTermTotal = getMaxFinancedAmount(approvalTerm)
            const maxTermAmount = getMaxFinancedAmount(maxFinancedTerm)

            if (currentApprovalTermTotal > maxTermAmount) {
                return approvalTerm
            }

            return maxFinancedTerm
        },
        null,
    )
}
